module.exports = __webpack_public_path__ + "img/bubble box.9e19f67c.png";